export default "__VITE_ASSET__BWkFLlR0__"